var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRegistro = function SvgRegistro(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.818 140.919",
    enableBackground: "new 0 0 141.818 140.919",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 71.115,
    cy: 70.45,
    r: 70
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003826268948878610620000015177519384923540111_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1.115,
    y: 0.16,
    clipPath: "url(#SVGID_00000003826268948878610620000015177519384923540111_)",
    fill: "#E6F8F8",
    width: 140,
    height: 140
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000003826268948878610620000015177519384923540111_)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    d: "M49.33,92.925h7.444v9.311c0,0.715-0.125,1.058-0.188,1.199h-9.692c-5.889,0-11.028,3.991-12.458,9.72 l-3.21,13.289H1.121l5.627-23.252l0.78-3.241c1.012-4.037,4.671-7.025,9.024-7.025h10.054c0.318,0,3.366-0.269,3.366-4.721 c0-4.459,0-18.112,0-18.112l0.012-2.917c0-7.184,5.801-12.314,13.008-12.314c10.741,0,13.114,12.764,13.114,12.764l1.63,7.816 h-3.647v8.183c0,1.242-1.005,2.242-2.236,2.242h-5.876v3.456C45.977,89.322,45.977,92.925,49.33,92.925z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64AD97",
    d: "M141.108,126.444h-36.307l-2.36-9.736l-0.893-3.587c-1.455-5.694-6.564-9.685-12.446-9.685h-6.789 c3.129-0.072,5.646-2.636,5.646-5.789v-4.655h0.112c0.231,0,0.456-0.016,0.675-0.066h4.758c0.319,0,3.354-0.269,3.354-4.721 c0-4.459,0-18.112,0-18.112l0.019-2.917c0-7.184,5.808-12.314,13.008-12.314c10.759,0,13.12,12.764,13.12,12.764l1.611,7.816 h-3.641v8.183c0,1.242-1.005,2.242-2.241,2.242h-5.864v3.456c0,0,0,3.603,3.335,3.603h9.448c4.353,0,8,2.988,9.024,7.025 l0.887,3.557L141.108,126.444z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1137C",
    d: "M104.558,140.482h-73.1l5.62-23.249l0.793-3.238c1.012-4.038,4.665-7.032,9.024-7.032h10.066 c0.312,0,3.347-0.26,3.347-4.737c0-4.446,0-18.094,0-18.094l0.025-2.92c0-7.19,5.808-12.318,13.008-12.318 c10.741,0,13.114,12.764,13.114,12.764l1.623,7.818h-3.647v8.177c0,1.249-1.012,2.248-2.248,2.248H76.32v3.45 c0,0,0,3.61,3.341,3.61h9.442c4.346,0,7.999,2.994,9.029,7.032l0.874,3.56L104.558,140.482z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000003826268948878610620000015177519384923540111_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    d: "M72.131,42.355L72.131,42.355c-12.4,0-22.451-10.051-22.451-22.45v0c0-12.399,10.051-22.45,22.45-22.45h0 c12.399,0,22.45,10.051,22.45,22.45v0C94.581,32.304,84.529,42.355,72.131,42.355z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M69.214,23.96c0-1.583,0.179-2.833,0.537-3.749c0.358-0.916,0.938-1.71,1.74-2.383 c0.803-0.672,1.412-1.288,1.83-1.846c0.418-0.559,0.626-1.174,0.626-1.846c0-1.637-0.705-2.456-2.114-2.456 c-0.65,0-1.177,0.239-1.578,0.716c-0.401,0.477-0.613,1.122-0.634,1.935h-5.498c0.022-2.168,0.705-3.857,2.049-5.066 c1.345-1.209,3.231-1.814,5.66-1.814c2.418,0,4.291,0.558,5.619,1.675c1.328,1.117,1.992,2.705,1.992,4.765 c0,0.9-0.179,1.719-0.537,2.456c-0.358,0.737-0.933,1.491-1.724,2.261l-1.87,1.74c-0.531,0.509-0.9,1.033-1.106,1.569 c-0.206,0.537-0.32,1.217-0.342,2.041H69.214z M68.547,28.904c0-0.802,0.29-1.461,0.87-1.976c0.58-0.515,1.304-0.773,2.171-0.773 c0.867,0,1.591,0.258,2.171,0.773c0.58,0.515,0.87,1.174,0.87,1.976c0,0.802-0.29,1.461-0.87,1.976 c-0.58,0.515-1.304,0.772-2.171,0.772c-0.868,0-1.591-0.257-2.171-0.772C68.837,30.366,68.547,29.707,68.547,28.904z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#929292",
    points: "67.727,39.04 72.014,59.137 78.42,28.993  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#929292",
    points: "59.038,21.083 45.59,50.422 64.001,29.807  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#929292",
    points: "84.782,23.775 97.118,50.689 80.229,31.778  "
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRegistro, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/registro.e121a8c7.svg";
export { ForwardRef as ReactComponent };